import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDecodedParams } from "../misc/utils";

const DonationResultPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id } = useDecodedParams();

  return (
    <div className="page-view event-detail">
      <img
        className="logo mt-2 mb-6"
        src="/EP_logo_withwords-01.png"
        alt="pause-and-breathe-logo"
      />
      <form
        key="userInfoForm"
        id="userInfoForm"
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      >
        <div
          className={`card-view donation-card donation-result-card`}
          style={{ marginBottom: "40px" }}
        >
          {/* <h1 className="mb-1">{t("Donation")}</h1> */}
          {id === "2430e09" ? (
            <>
              <h1 className="mb-1">{t("Donation Success Result")}</h1>
              <h4>
                Your payment has been completed, and a confirmation email has
                been sent to your mailbox. Thanks you! Please contact
                cs@elite-paradise.tech with any questions regarding this
                transaction .
                <a href="cs@elite-paradise.tech">cs@elite-paradise.tech</a>
              </h4>
            </>
          ) : id === "failed" ? (
            <>
              <h1 className="mb-1">{t("Donation Fail Result")}</h1>
              <h4>
                {t("old class")}
                <a href="cs@elite-paradise.tech">cs@elite-paradise.tech</a>
              </h4>
            </>
          ) : id === "fail" ? (
            <>
              <h1 className="mb-1">{t("Donation Transaction Fail Result")}</h1>
              <h4>
                抱歉，系統或輸入資料出錯，請重新輸入。
                如果對事項操作有問任何問題，請與
                <a href="cs@elite-paradise.tech">cs@elite-paradise.tech</a>
              </h4>
            </>
          ) : null}
        </div>
        <div className={`my-5 btns-gp-div`}>
          <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              navigate("/donation");
            }}
          >
            {t("Back")}
          </Button>
        </div>
      </form>
      {/* <div>{`event ${id || "none"}`}</div> */}
    </div>
  );
};

export default DonationResultPage;
